import React, { useEffect, useState } from "react";
import { LifetimeDealModal } from "./lifetime-deal-modal";

const SESSION_KEY = "lifetime_deal_modal_shown";

export const SessionLifetimeDealModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasShown = sessionStorage.getItem(SESSION_KEY);
    if (!hasShown) {
      setIsOpen(true);
      sessionStorage.setItem(SESSION_KEY, "true");
    }
  }, []);

  return (
    <LifetimeDealModal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      variant="public"
    />
  );
};
